import { CaseIncludedField } from 'app/area/case-report/case-listing/types';
import { transformSelectedReport } from 'app/area/favourite/favourite-definition-transforms/selected-report';
import { FavouriteDefinition } from 'app/types-shared';

export const updateIncludedDomains = (def: FavouriteDefinition, includedFields: CaseIncludedField[]) =>
  transformSelectedReport({
    includedFields
  })(def);
